import { Container } from "../../primitives/container";
import React from "react";
import { Skeleton } from "../skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../table";

export const TableSkeleton: React.FC = () => {
    return (
        <Container className="p-6">
            <div className="mb-6">
                <Skeleton className="mb-1 h-3 w-32" />
                <Skeleton className="mb-2 h-7 w-24" />
                <Skeleton className="h-4 w-96" />
            </div>

            <div className="mb-4 flex items-center gap-3">
                <Skeleton className="h-9 w-64" />
                <Skeleton className="h-9 w-32" />
            </div>

            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className="text-right">
                            <Skeleton className="h-4 w-20 rounded" />
                        </TableHead>
                        <TableHead className="text-right">
                            <Skeleton className="h-4 w-20 rounded" />
                        </TableHead>
                        <TableHead className="text-right">
                            <Skeleton className="h-4 w-20 rounded" />
                        </TableHead>
                        <TableHead className="text-right">
                            <Skeleton className="h-4 w-20 rounded px-4" />
                        </TableHead>
                        <TableHead className="text-right">
                            <Skeleton className="h-4 w-20 rounded" />
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array.from({ length: 8 }).map((_, i) => (
                        <TableRow key={i}>
                            <TableCell className="w-10 px-4">
                                <Skeleton className="h-4 w-4 rounded" />
                            </TableCell>
                            <TableCell className="w-8 px-2">
                                <Skeleton className="h-6 w-6 rounded" />
                            </TableCell>
                            <TableCell>
                                <Skeleton className="h-4 w-32" />
                            </TableCell>
                            <TableCell className="text-right">
                                <Skeleton className="ml-auto h-4 w-6" />
                            </TableCell>
                            <TableCell className="text-right">
                                <div className="flex items-center justify-end gap-1">
                                    <Skeleton className="h-7 w-7 rounded" />
                                    <Skeleton className="h-7 w-7 rounded" />
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Container>
    );
};
